import { PracticeCityZone } from './practice-city-zone';
import { CriticalPoint } from './practice-path';

export class PracticeCity {
  uuid:string;
  city:string;
  countOfExamPath:number;
  nodes:Array<CityNode>;
  criticalPoints:Array<CriticalPoint>;
  contentResponsibles:Array<string>;
  isVisible?:boolean;
  cityNodeUuidsAssigmentToExamThesis:Array<Array<string>>;
  practicePathUuids:Array<string>;
  zones: PracticeCityZone[];
  status: "TODO" | "IN_PROGRESS" | "DONE";
  isZoneEnabled: boolean;
}

export class CityNode {
  uuid:string;
  name:string;
  isFree?:boolean;
  imageUrl?:string;
  isVisible?:boolean;
  isMainNode?: boolean;
  blurhashOfImage?: string;
}

export function practiceCitySorter(practiceCity1:PracticeCity, practiceCity2:PracticeCity):number {
  // Order: IN_PROGRESS first, then TODO, then DONE, then by city name
  const statusOrder = { "IN_PROGRESS": 0, "TODO": 1, "DONE": 2 };
  const status1 = statusOrder[practiceCity1.status] ?? 99;
  const status2 = statusOrder[practiceCity2.status] ?? 99;
  if (status1 !== status2) {
    return status1 - status2;
  }
  return practiceCity1.city.localeCompare(practiceCity2.city);
}

export function practiceCityNodeSorter(cityNode1:CityNode, cityNode2:CityNode):number {
  return cityNode1.name.localeCompare(cityNode2.name);
}


/** This is the fields of the PracticeCityBaseInformations type. */
export const practiceCityBaseInformationsFields:Array<keyof PracticeCity> = [
  "uuid", "city", "nodes", "cityNodeUuidsAssigmentToExamThesis", "countOfExamPath", "practicePathUuids", "zones"
];

/**
 * Reduced type or the PracticeCity.
 * NOTE: If this type is changed, modify the `practiceCityBaseInformationsFields` accordingly.
 */
export type PracticeCityBaseInformations = {
  uuid:string;
  city:string;
  nodes:Array<CityNode>;
  cityNodeUuidsAssigmentToExamThesis:Array<Array<string>>;
  countOfExamPath:number;
  practicePathUuids:Array<string>;
  zones: Array<PracticeCityZone>
}
